import { createPortal } from "react-dom";

export default function BulkValueModal({
  title,
  count,
  value,
  onChange,
  onClose,
  onApply,
  options,
  placeholder = "Enter value",
}) {
  const control = options?.length ? (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={inputStyle}
      autoFocus
    >
      <option value="">Select...</option>
      {options.map((option) => (
        <option key={option.value ?? option} value={option.value ?? option}>
          {option.label ?? option}
        </option>
      ))}
    </select>
  ) : (
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={inputStyle}
      autoFocus
    />
  );

  return createPortal(
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 2300, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div style={{ background: "#fff", borderRadius: 12, padding: "20px 22px", minWidth: 320, maxWidth: 440, width: "100%", boxShadow: "0 20px 50px rgba(0,0,0,0.2)" }}>
        <h3 style={{ margin: "0 0 12px", fontSize: 16, fontWeight: 700, color: "#1F2937" }}>{title}</h3>
        <p style={{ margin: "0 0 12px", fontSize: 12, color: "#6B7280" }}>Applies to {count} selected row{count === 1 ? "" : "s"}.</p>
        {control}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 18 }}>
          <button type="button" onClick={onClose} style={{ padding: "8px 16px", border: "1px solid #E5E7EB", borderRadius: 8, background: "#fff", fontSize: 13, cursor: "pointer" }}>Cancel</button>
          <button type="button" onClick={onApply} style={{ padding: "8px 16px", border: "none", borderRadius: 8, background: "#976793", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Apply</button>
        </div>
      </div>
    </div>,
    document.body
  );
}

const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  background: "#F9FAFB",
  fontSize: 13,
  color: "#374151",
  outline: "none",
  fontFamily: "inherit",
};
